// styling for active etc

export function checkboxTabs() {
    const tabs = document.querySelector<HTMLElement>(".checkbox-tabs");

    if (tabs) {
        const allRadios: NodeList = tabs.querySelectorAll("input");
        const allRelationContainer: NodeList | null = document.querySelectorAll(
            "[data-relation-content]",
        ) as NodeList;
        const firstContainer: HTMLElement =
            allRelationContainer[0] as HTMLElement;
        firstContainer.classList.add("active");

        for (let i: number = 0; i < allRadios.length; i++) {
            allRadios[i].addEventListener("click", function (e) {
                const eventTarget: HTMLElement = e.target as HTMLElement;
                const dataRelation: string = eventTarget.getAttribute(
                    "data-relation",
                ) as string;
                const relationContainer: HTMLElement | null =
                    document.querySelector(
                        `[data-relation-content=${dataRelation}]`,
                    ) as HTMLElement;

                for (let i: number = 0; i < allRelationContainer.length; i++) {
                    const relationElement: HTMLElement = allRelationContainer[
                        i
                    ] as HTMLElement;
                    relationElement.classList.remove("active");
                }

                relationContainer.classList.add("active");
                relationContainer.scrollIntoView();
            });
        }
    }
}
